import type { LinkPaymentMethod } from '../../openApi';
import { OrderPaymentMethods } from './OrderPaymentMethods';

export const OrderPostPaymentMethods: Array<LinkPaymentMethod> = [
    OrderPaymentMethods.CARD_ON_DELIVERY,
    OrderPaymentMethods.CASH_ON_DELIVERY,
];
